import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { PalletDefect } from "../../types/palletDefect";
import { Culture } from "../../types/culture";
import { DefectType } from "../../types/defectType";
import { renderSingleDefectName } from "../../aplUtils/defectsHelper";

const palstatEditDefectsColumnData = (siteId: number, culture: Culture, defectTypes: DefectType[]): ConfigColumns2[] => {
    return [
        {
            data: "defectId",
            className: "nowrap",
            width: "40%",
            title: "rxg_defectsTable_Defect",
            render: function (data: PalletDefect, type: ColumnFilterOrDisplayType | undefined) {
                if (!data) return "";
                return type === "sort" ? data.defectId.toString().padStart(5, '0') : `${renderSingleDefectName(data.defectId, defectTypes)}`;
            }
        },
        {
            data: "dtoDefectTimeStamp",
            className: "nowrap",
            render: function (data: PalletDefect, type: ColumnFilterOrDisplayType | undefined) {
                if (!data) return "";
                return type === "sort" ? data.dtoDefectTimeStamp : momentDtoToLocalStringByCulture(data.dtoDefectTimeStamp, culture);
            },
            width: "25%",
            title: "date"
        },
        { data: "initials", className: "nowrap", width: "20%", title: "rxg_defectsTable_Initials" },
        { data: "comment", className: "nowrap", width: "20%", title: "rxg_defectsTable_Comment" },
        { data: "mouldNo", className: "nowrap", width: "10%", title: "mouldNo" }
    ];
};


export { palstatEditDefectsColumnData }
